'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _reactRedux = require('react-redux');

var _events = require('redux/modules/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchSetRecurrences: function dispatchSetRecurrences(recurrences) {
      dispatch((0, _events.setRecurrences)(recurrences));
    }
  };
};

var RecurrencesButtonContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.events.loading,
    location: state.router.location,
    recurrences: state.events.recurrences
  };
}, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RecurrencesButtonContainer, _Component);

  function RecurrencesButtonContainer() {
    (0, _classCallCheck3.default)(this, RecurrencesButtonContainer);
    return (0, _possibleConstructorReturn3.default)(this, (RecurrencesButtonContainer.__proto__ || (0, _getPrototypeOf2.default)(RecurrencesButtonContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecurrencesButtonContainer, [{
    key: 'handleSetRecurrences',
    value: function handleSetRecurrences(recurrences) {
      if (this.props.loading) {
        return;
      }

      this.props.dispatchSetRecurrences(recurrences);

      var location = this.props.location;

      var newQuery = (0, _extends3.default)({}, location.query, {
        recurrences: recurrences
      });
      var newLocation = (0, _extends3.default)({}, location, {
        query: newQuery
      });

      this.context.router.push(newLocation);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var polyglot = this.context.polyglot;

      var properties = {
        recurrences: this.props.recurrences,
        handleSetRecurrences: function handleSetRecurrences() {
          _this2.handleSetRecurrences(!_this2.props.recurrences);
        },
        title: polyglot.t('event.hideRepeatingEvents')
      };
      return this.props.children(properties);
    }
  }]);
  return RecurrencesButtonContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.func,
  dispatchSetRecurrences: _react.PropTypes.func,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  recurrences: _react.PropTypes.bool.isRequired
}, _class2.contextTypes = {
  polyglot: _react.PropTypes.object,
  router: _react.PropTypes.object
}, _class2.defaultProps = {
  children: function children(_ref) {
    var recurrences = _ref.recurrences,
        handleSetRecurrences = _ref.handleSetRecurrences,
        title = _ref.title;

    return _react2.default.createElement(_caligramReact.Checkbox, { action: handleSetRecurrences, checked: !recurrences, id: 'recurrences', title: title });
  }
}, _temp)) || _class);
exports.default = RecurrencesButtonContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecurrencesButtonContainer.js
// module id = 1099
// module chunks = 0